<template>
    <div class="match-main">
        <van-sticky>
        <div class="home_header">
            <van-search
            v-model="keywords"
            show-action
            placeholder="请输入搜索关键词"
            @search="getlist"
            >
                <template #action>
                    <div @click="getlist">搜索</div>
                </template>
            </van-search>
            <van-dropdown-menu active-color="#1989fa">
                <!-- <van-dropdown-item get-container="body" title="区域筛选" @change="getlist" v-model="district" :options="dlist" /> -->
                <van-dropdown-item get-container="body" title="月份筛选" @change="getlist" v-model="month" :options="mlist" />
                <van-dropdown-item get-container="body" title="板块筛选" @change="getlist" v-model="match_plate_id" :options="plist" />
            </van-dropdown-menu>
        </div>
        </van-sticky>
        <div class="list">
            <div class="blist" v-for="item in list" :key="item.id">
                <div class="bitem">
                    <div class="bt">
                        <div class="btitle threeline">
                            <span>{{item.title}}</span>
                        </div>
                        <div class="btime">赛事编号：{{item.number}}</div>
                        <div class="btime">开始时间：{{item.date}}</div>
                        <div class="btime">提交时间：{{item.ctime}}</div>
                    </div>
                    <div class="bb">
                        <div class="btips">#{{item.match_level}} #{{item.match_plate}} #{{item.status ==1?"已提交":"暂存"}} #{{item.base_id>0?'已关联':'未关联'}}</div>
                        <div class="btn" @click="godetail(item)" >查看详情</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import './index.less'
    import moment from 'moment';
    import { Swipe, SwipeItem, Tag,Cell, CellGroup,Image,Button,Popup,Sticky,Search,DropdownMenu, DropdownItem  } from 'vant';
    export default {
        data() {
            return {
                show: false,
                list: [],
                registerform: [],
                keywords: '',
                district: '0',
                match_plate_id: '0',
                month: '0',
                state: '0',
                dlist: [
                    {text: "全部", value: "0"},
                    {text: "静安区", value: "静安区"},
                    {text: "黄浦区", value: "黄浦区"},
                    {text: "徐汇区", value: "徐汇区"},
                    {text: "长宁区", value: "长宁区"},
                    {text: "虹口区", value: "虹口区"},
                    {text: "普陀区", value: "普陀区"},
                    {text: "闵行区", value: "闵行区"},
                    {text: "宝山区", value: "宝山区"},
                    {text: "杨浦区", value: "杨浦区"},
                    {text: "浦东新区", value: "浦东新区"},
                    {text: "松江区", value: "松江区"},
                    {text: "嘉定区", value: "嘉定区"},
                    {text: "青浦区", value: "青浦区"},
                    {text: "金山区", value: "金山区"},
                    {text: "奉贤区", value: "奉贤区"},
                    {text: "崇明区", value: "崇明区"}
                ],
                mlist: [
                    {text: "全部", value: "0"},
                    {text: "一月", value: "01"},
                    {text: "二月", value: "02"},
                    {text: "三月", value: "03"},
                    {text: "四月", value: "04"},
                    {text: "五月", value: "05"},
                    {text: "六月", value: "06"},
                    {text: "七月", value: "07"},
                    {text: "八月", value: "08"},
                    {text: "九月", value: "09"},
                    {text: "十月", value: "10"},
                    {text: "十一月", value: "11"},
                    {text: "十二月", value: "12"},
                ],
                slist: [
                    {text: "全部", value: "0"},
                    {text: "已关联", value: "1"},
                    {text: "未关联", value: "2"},
                ],
                plist: [],
            }
        },
        components: {
            vanSwipe: Swipe,
            vanSwipeItem: SwipeItem,
            vanTag: Tag,
            VanCell: Cell,
            VanImage: Image,
            VanButton: Button,
            VanDropdownMenu: DropdownMenu,
            VanDropdownItem: DropdownItem,
            VanPopup: Popup,
            VanSearch: Search,
            VanSticky: Sticky,
            VanCellGroup: CellGroup
        },
        methods: {
            godetail(item) {
                this.$router.push({name:'matchdetail',params: {evid: item.id}})
            },
            getlist() {
                let query = {
                    page: 1,
                    keywords: this.keywords,
                    district: this.district,
                    month: this.month,
                    match_plate_id: this.match_plate_id
                }
               this.$api.match.getEnvList(query).then(res=>{
                    let {
                        list,
                        platelist
                    } = res.data;
                    let arr = [{text:'全部',value:'0'}]
                    platelist.forEach(item=>{
                        arr.push({
                            text: item.match_plate,
                            value: item.match_plate_id
                        })
                    })
                    this.plist = arr
                    list.forEach((row)=>{
                        row.date = moment(row.start_time * 1000).format("YYYY/MM/DD");
                        row.ctime = moment(row.create_time * 1000).format("YYYY/MM/DD HH:mm");
                        
                    })
                    this.list = list
               }) 
            }
        },
        mounted() {
            this.getlist()
        }
    }
</script>